import "./Trucks.module.css";
import Header from "@/reusable_sections/Header";
import YourFleetAwaits from "./sections/YourFleetAwaits";
import ExploreOurTruckModels from "./sections/ExploreOurTruckModels";
import Footer from "@/reusable_sections/Footer";
export default function TrucksPage() {
  return <div>
      <Header />
      <YourFleetAwaits />
      <ExploreOurTruckModels />
      <Footer />
    </div>;
}